export default {"src":"/_next/static/media/referAfriend.f7735bf9.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};